import { useState } from "react";
import { fetchProblemList } from "../../utils/patients/fetchProblemList";
import useProfileStore from "../../store/patient/profileStore";




const useManageProblemList = () => {
    const [loading, setLoading] = useState(false);
    const [probList, setProbList] = useState([]);
    const {profile} = useProfileStore()



  const handleFetchProbList = async () => {
    setLoading(true);
    try{
      const response = await fetchProblemList(profile?.id)
      
      setProbList(response.data);
      console.log(response.data);
      
    } catch(err) {
      console.log(err)
      window.location.href = "/pages/signin2";
      console.log("error error");

    } finally {
      setLoading(false)
    }
  };


  return {
    handleFetchProbList,
    loading,
    probList
  };

}

export default useManageProblemList;